import { CountResponse } from '@interfaces/common.interface';
import {
  CountMedicalOrganizationsAddressesRequest,
  CreateMedicalOrganizationAddressRequestBody,
  MedicalOrganizationAddress,
  UpdateMedicalOrganizationAddressRequest,
} from '@interfaces/medicalOrganizationsAddresses.interface';

import api from './';

export const {
  useCountMedicalOrganizationsAddressesQuery,
  useGetManyMedicalOrganizationsAddressesQuery,
  useCreateMedicalOrganizationAddressMutation,
  useUpdateMedicalOrganizationAddressMutation,
  useDeleteMedicalOrganizationAddressMutation,
} = api.injectEndpoints({
  endpoints: (build) => ({
    countMedicalOrganizationsAddresses: build.query<
      CountResponse,
      CountMedicalOrganizationsAddressesRequest
    >({
      query: ({ medicalOrganizationId, params }) => ({
        url: `medical-organizations/${medicalOrganizationId}/medical-organizations-addresses/count`,
        params,
      }),
      providesTags: ['medicalOrganizationsAddresses'],
    }),
    getManyMedicalOrganizationsAddresses: build.query<
      MedicalOrganizationAddress[],
      CountMedicalOrganizationsAddressesRequest
    >({
      query: ({ medicalOrganizationId, params }) => ({
        url: `medical-organizations/${medicalOrganizationId}/medical-organizations-addresses`,
        params,
      }),
      providesTags: ['medicalOrganizationsAddresses'],
    }),
    createMedicalOrganizationAddress: build.mutation<
      MedicalOrganizationAddress,
      CreateMedicalOrganizationAddressRequestBody
    >({
      query: (body) => ({
        url: 'medical-organizations-addresses',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['medicalOrganizationsAddresses'],
    }),
    updateMedicalOrganizationAddress: build.mutation<
      MedicalOrganizationAddress,
      UpdateMedicalOrganizationAddressRequest
    >({
      query: ({ id, body }) => ({
        url: `medical-organizations-addresses/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['medicalOrganizationsAddresses'],
    }),
    deleteMedicalOrganizationAddress: build.mutation<
      MedicalOrganizationAddress,
      string
    >({
      query: (id) => ({
        url: `medical-organizations-addresses/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['medicalOrganizationsAddresses'],
    }),
  }),
});
